import React from 'react';
import { dailyMoments } from '../data/content';
export function DailyMoment() {
  return <section className="w-full bg-ivory py-14 md:py-24" data-id="element-30" data-mp="2bi6f5nti10aq">
      <div className="mx-auto w-full max-w-5xl px-5 md:px-8" data-id="element-31" data-mp="2bglkly76phcv">
        <header className="mx-auto max-w-3xl text-center" data-id="element-32" data-mp="2gag2qx755o9u">
          <h2 className="font-serif text-3xl font-semibold leading-tight text-ink md:text-5xl" data-id="element-33" data-mp="2l8hu05eq0twe">
            Tu momento de oración, preparado cada día
          </h2>
          <p className="mx-auto mt-5 max-w-2xl text-lg text-muted md:text-xl" data-id="element-34" data-mp="1nmk6tupec0e4">
            No necesitas preguntarte qué rezar, qué leer o por dónde empezar.
          </p>
          <p className="mx-auto mt-3 max-w-2xl text-lg font-semibold text-wine md:text-xl" data-id="element-35" data-mp="1xhvn4hggdfnz">
            Abres el día que corresponde y encuentras tu momento preparado.
          </p>
        </header>

        <ul className="mx-auto mt-10 grid max-w-4xl gap-4 md:mt-14 md:grid-cols-3 md:gap-5" data-id="element-36" data-mp="38x0sxubvrubt">
          {dailyMoments.map(moment => <li key={moment.title} className="flex h-full items-start gap-4 rounded-2xl bg-cream p-5 ring-1 ring-line md:flex-col md:items-center md:p-7 md:text-center" data-id="element-37" data-mp="3dz9p0zk1vci5">
              <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-ivory text-2xl ring-1 ring-gold/50 md:h-14 md:w-14" aria-hidden="true" data-id="element-38" data-mp="27v5qltldgx8k">
                {moment.emoji}
              </span>
              <div data-id="element-39" data-mp="1tys6sdtd8jqx">
                <h3 className="font-serif text-xl font-semibold text-ink md:mt-1 md:text-2xl" data-id="element-40" data-mp="1tza9ntaj9w7t">
                  {moment.title}
                </h3>
                <p className="mt-1.5 leading-relaxed text-muted" data-id="element-41" data-mp="1k6me11vahyao">{moment.text}</p>
              </div>
            </li>)}
        </ul>

        <p className="mx-auto mt-10 max-w-2xl text-center text-lg leading-relaxed text-ink md:text-xl" data-id="element-42" data-mp="1g3pth5m6vs43">
          Unos minutos al día para detenerte, reflexionar y caminar junto a María durante octubre.
        </p>
      </div>
    </section>;
}